import { Container, Grid2, TextField, Typography } from "@mui/material";
import AdvertisementTypes from "components/common/AdvertisementTypes";
import TextAreaEditor from "components/common/TextAreaEditor";
import PronounSelect from "components/contact/InfoSection/common/PronounSelect";
import CompanySelect from "components/global/CompanySelect";
import MuiPhoneNumber from "material-ui-phone-number";
import PropTypes from "prop-types";
import React, { Fragment, forwardRef, useImperativeHandle } from "react";
import AddContactList from "../common/AddContactList";
import ReadOnlyForm from "../../../common/form/ReadOnlyForm";
import { getFullAddress } from "../../utils";

const OUTSIDE_SPACING = 6;
const INSIDE_SPACING = 2;

// eslint-disable-next-line react/display-name
const ContactForm = forwardRef((props, ref) => {
    const {
        disabled,
        handleSubmit,
        values,
        handleChange,
        setFieldValue,
        handleBlur,
        errors,
        touched,
        contactFormCopyMode,
    } = props;

    const valueRef = React.useRef();

    useImperativeHandle(ref, () => ({
        submit: (e) => {
            setFieldValue("note", valueRef.current.getValue());
            handleSubmit(e);
        },
    }));

    function getCommonProps(name) {
        return {
            name: name,
            onBlur: handleBlur,
            value: values[name],
            onChange: handleChange,
            error: touched[name] && errors[name] ? errors[name] : null,
            helperText: touched[name] && errors[name] ? errors[name] : null,
            variant: "outlined",
            fullWidth: true,
        };
    }

    function handleChangeAdvertisement(adv) {
        setFieldValue("advTypes", [...adv]);
    }

    function handleChangePhone(phone, field) {
        setFieldValue(field, phone);
    }

    function handleChangeCompany(company) {
        setFieldValue("company", company);
    }

    function handlePronounChange(pronoun) {
        setFieldValue("pronoun", pronoun);
    }

    const labelProps = {
        size: { xs: 12 },
    };
    const showAssistantValues = (!disabled || (values.assistant || values.assistantEmail || values.assistantPhone));
    const showAddressValues = (!disabled || getCommonProps("pronoun").value || ((values.addressList && values.addressList.length > 0) && (values.addressList[0].phone1 || values.addressList[0].phone2 || values.addressList[0].fax || values.addressList[0].email || getFullAddress(values.addressList[0])))) ? true : false;
    return (
        <Fragment>
            <Container component="form">
                <form onSubmit={handleSubmit}>
                    <Grid2 container spacing={OUTSIDE_SPACING}>
                        {contactFormCopyMode && (
                            <Grid2 container spacing={INSIDE_SPACING} size={{ xs: 12 }}>
                                <Grid2 {...labelProps}>
                                    <Typography>Company</Typography>
                                </Grid2>
                                <Grid2 size={12}>
                                    <CompanySelect onChange={handleChangeCompany} defaultValue={values.company} />
                                </Grid2>
                            </Grid2>
                        )}
                        {((values.advTypes && values.advTypes.length > 0 && disabled) || !disabled) &&
                            <Grid2 container spacing={INSIDE_SPACING} size={{ xs: 12 }}>
                                <Grid2 {...labelProps}>
                                    <Typography>Advertising contact for:</Typography>
                                </Grid2>
                                <Grid2 size={{ xs: 12 }}>
                                    <ReadOnlyForm readOnly={disabled} value={values.advTypes} type={"list"}
                                        listLabel={"name"}
                                        label={null}>
                                        <AdvertisementTypes
                                            placeholder="Multiple advertising values"
                                            disabled={disabled}
                                            onChange={handleChangeAdvertisement}
                                            value={values.advTypes}
                                        />
                                    </ReadOnlyForm>
                                </Grid2>
                            </Grid2>}

                        {!disabled && <Grid2 container spacing={INSIDE_SPACING} size={{ xs: 12 }}>
                            <Grid2 container size={{ xs: 12 }} spacing={INSIDE_SPACING}>
                                <Grid2 {...labelProps}>
                                    <Typography>Full name:</Typography>
                                </Grid2>
                                <Grid2 size={{ xs: 6 }}>
                                    <TextField
                                        {...getCommonProps("firstName")}
                                        placeholder="First Name"
                                        disabled={disabled}
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 6 }}>
                                    <TextField
                                        {...getCommonProps("lastName")}
                                        placeholder="Last Name"
                                        disabled={disabled}
                                    />
                                </Grid2>
                                <Grid2
                                    container
                                    spacing={1}
                                    minWidth={0}
                                    size={{
                                        xs: 12,
                                        sm: 6
                                    }}>
                                    <Grid2 size={{ xs: 12 }}>
                                        <Typography>Title:</Typography>
                                    </Grid2>
                                    <Grid2
                                        size={{
                                            xs: 12
                                        }}>
                                        <TextField
                                            {...getCommonProps("title")}
                                            placeholder="Title"
                                            disabled={disabled}
                                        />
                                    </Grid2>
                                </Grid2>
                                <Grid2
                                    container
                                    spacing={1}
                                    minWidth={0}
                                    size={{
                                        xs: 12,
                                        sm: 6
                                    }}>
                                    <Grid2 size={{ xs: 12 }}>
                                        <Typography>Pronoun:</Typography>
                                    </Grid2>
                                    <Grid2
                                        size={{
                                            xs: 12
                                        }}>
                                        <PronounSelect
                                            {...getCommonProps("pronoun")}
                                            onChange={handlePronounChange}
                                            placeholder="Pronoun"
                                            disabled={disabled}
                                        />
                                    </Grid2>
                                </Grid2>
                            </Grid2>
                        </Grid2>}

                        {showAddressValues && <Grid2 size={{ xs: 12 }}>
                            {getCommonProps("pronoun").value && disabled &&
                                <Grid2
                                    container
                                    spacing={5}
                                    paddingBottom={1}
                                    minWidth={0}
                                    size={{
                                        xs: 12,
                                        sm: 6
                                    }}>
                                    <Grid2 size={{ xs: 12 }}>
                                        <Typography>Pronoun:</Typography>
                                    </Grid2>
                                    <Grid2
                                        marginLeft={3}
                                        size={{
                                            xs: 12
                                        }}>
                                        <span>{getCommonProps("pronoun").value}</span>
                                    </Grid2>
                                </Grid2>}
                            <AddContactList
                                disabled={disabled}
                                values={values}
                                setFieldValue={setFieldValue}
                                commonProps={getCommonProps}
                                onChangePhone={handleChangePhone}
                                errors={errors.addressList}
                                touched={touched.addressList}
                                xs={12}
                                lg={6}
                            />
                        </Grid2>}
                        {showAssistantValues && <Grid2 size={{ xs: 12 }}>
                            <Typography variant={"button"}>Assistant Contact</Typography>
                        </Grid2>}
                        {(values.assistant || values.assistantEmail || values.assistantPhone || !disabled) && <Grid2 marginTop={-4} container={!disabled} size={{ xs: 12 }} spacing={INSIDE_SPACING}>
                            {(values.assistant || !disabled) && <Grid2 paddingBottom={1} size={{ xs: 12, md: 7 }}>
                                <ReadOnlyForm readOnly={disabled} label={"Name"} value={values.assistant}>
                                    <TextField {...getCommonProps("assistant")}
                                        placeholder="Name" disabled={disabled} />
                                </ReadOnlyForm>

                            </Grid2>}
                            {(values.assistantEmail || !disabled) && <Grid2  paddingBottom={1} size={{ xs: 12, md: 7, lg: 7 }} spacing={1} >
                                <ReadOnlyForm readOnly={disabled} label={"Email"} value={values.assistantEmail}>
                                    <TextField
                                        {...getCommonProps("assistantEmail")}
                                        value={values.assistantEmail}
                                        disabled={disabled}
                                        placeholder="Email: example@ex.com"
                                    />
                                </ReadOnlyForm>

                            </Grid2>}
                            {(values.assistantPhone || !disabled) && <Grid2 size={{ xs: 12, md: 5, lg: 5 }}  >
                                <ReadOnlyForm readOnly={disabled} label={"Phone"} value={values.assistantPhone}>
                                    <MuiPhoneNumber
                                        disableAreaCodes
                                        disableCountryCode
                                        variant="outlined"
                                        defaultCountry={"us"}
                                        onlyCountries={["us"]}
                                        fullWidth
                                        disabled={disabled}
                                        onChange={(phone) => handleChangePhone(phone, "assistantPhone")}
                                        value={values.assistantPhone}
                                        error={errors && touched && touched.assistantPhone ? errors.assistantPhone : null}
                                        helperText={errors && touched && touched.assistantPhone ? errors.assistantPhone : null}
                                        autoFormat={"on"}
                                        onBlur={getCommonProps("assistantPhone").onBlur}
                                        name={"assistantPhone"}
                                        placeholder={"Phone"}
                                    />
                                </ReadOnlyForm>
                            </Grid2>}
                        </Grid2>}
                        <Grid2 size={{ xs: 12 }}>
                            <Typography>Note</Typography>
                        </Grid2>
                        <Grid2 size={{ xs: 12 }}>
                            <TextAreaEditor
                                ref={valueRef}
                                rootStyle={{ width: "100%", maxWidth: "100%" }}
                                defaultValue={values.note ? values.note : "<p></p>"}
                                readOnly={disabled}
                                active={!disabled}
                            />
                        </Grid2>
                    </Grid2>
                </form>
            </Container>
        </Fragment>
    );
});

ContactForm.propTypes = {
    disabled: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    values: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    setFieldValue: PropTypes.func.isRequired,
    handleBlur: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    touched: PropTypes.object.isRequired,
    contactFormCopyMode: PropTypes.bool,
};

export default ContactForm;
